<h2 mat-dialog-title>
  
    Lugar de entrega
</h2>
<div>
    <div mat-dialog-content>
        <p class="disclaimer">Seleccione lugar de entrega</p>
    </div>

    <div  mat-dialog-actions>
        <button mat-raised-button color="primary" class="button btnxlarge" (click)="exit('estacionamiento')">Estacionamiento</button>
        <button mat-raised-button color="primary" class="button btnxlarge" (click)="exit('meson')">Entrega en mesón</button>
        <button mat-raised-button color="primary" class="button btnxlarge" (click)="exit('pickup')">Trastienda Pickup</button>
    </div>

</div>
